import { CSSObject } from "styled-components";
import { Unit } from "../../../../../types/globals";

const cssObjectForActionButton = (
	colorHex: string | undefined,
	bgColorHex: string | undefined,
	borderColor: string | undefined,
	borderSize?: Unit
): CSSObject => {
	return {
		backgroundColor: bgColorHex,
		border: borderSize ? `${borderSize} solid ${borderColor}` : undefined,
		borderColor: !borderSize ? borderColor : undefined,
		".Typography": {
			color: colorHex,
		},
		".Icon svg": {
			fill: colorHex,
		},
	};
};

export default cssObjectForActionButton;
